import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { shallowRef } from "vue";
import { app } from "@/di";
import { LinkComponentManager } from "@/modules/vue/services/LinkComponentManager";
export default /*#__PURE__*/_defineComponent({
  __name: 'EntityLink',
  props: {
    entity: null,
    orientation: {
      default: 'left'
    },
    disabled: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    const component = shallowRef(app.get(LinkComponentManager).getComponent(props.entity));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_resolveDynamicComponent(_unref(component)), _mergeProps({
        entity: __props.entity
      }, _ctx.$attrs, {
        orientation: __props.orientation,
        disabled: __props.disabled
      }), null, 16, ["entity", "orientation", "disabled"]);
    };
  }
});